import { render, staticRenderFns } from "./ExerciseView.vue?vue&type=template&id=11fa461c&"
import script from "./ExerciseView.vue?vue&type=script&lang=js&"
export * from "./ExerciseView.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseView.vue?vue&type=style&index=0&id=11fa461c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports